<template>
  <label class="flex items-center">
    <div :class="{'radio-btn-disabled': disabled, 'radio-btn': !disabled }">
      <input
          :checked="value == modelValue"
          :disabled="disabled"
          :name="name"
          :value="value"
          type="radio"
          v-on:change="$emit('change', $event.target.value)"
      />
      <span class="checkmark"></span>
    </div>
    <div class="label">
      <slot></slot>
    </div>
  </label>
</template>

<script>
export default {
  model: {
    prop : 'modelValue',
    event: 'change'
  },
  props: {
    name      : String,
    value     : { default: '' },
    modelValue: { default: '' },
    disabled  : Boolean
  }
}
</script>

<style lang="scss" scoped>
.radio-btn {
  position: relative;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  height: 32px;
  width: 32px;
  border-radius: 50%;
  border: 1px solid #d8d4d9;
  background: white;
  transition: all 0.1s;
  display: flex;
  flex-direction: row;
  align-items: center;

  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  input:checked {
    border-color: #f75f39;
  }

  input:checked ~ .checkmark {
    background-color: #f75f39;
  }

  .radio-btn-disabled:checked {
    border-color: #e5dcda;
  }

  .radio-btn-disabled:checked ~ .checkmark {
    background-color: #948480;
  }

  .checkmark {
    position: absolute;
    top: 4px;
    left: 4px;
    height: 22px;
    width: 22px;
    border-radius: 50%;
    transition: all 0.1s;
  }

  &:hover {
    input:not([disabled]) ~ .checkmark {
      background-color: #fff7f5;
    }

    input:active ~ .checkmark {
      transform: scale(0.9);
    }

    input:checked ~ .checkmark {
      background: #de5b3b;
    }
  }
}

.radio-btn-disabled {
  position: relative;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  height: 32px;
  width: 32px;
  border-radius: 50%;
  border: 1px solid #d8d4d9;
  background: white;
  transition: all 0.1s;
  display: flex;
  flex-direction: row;
  align-items: center;

  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  input:checked {
    border-color: #eee5e3;
  }

  input:checked ~ .checkmark {
    background-color: #efddd8;
  }

  .radio-btn-disabled:checked {
    border-color: #e5dcda;
  }

  .radio-btn-disabled:checked ~ .checkmark {
    background-color: #948480;
  }

  .checkmark {
    position: absolute;
    top: 4px;
    left: 4px;
    height: 22px;
    width: 22px;
    border-radius: 50%;
    transition: all 0.1s;
  }

  &:hover {
    input:not([disabled]) ~ .checkmark {
      background-color: #fff7f5;
    }

    input:active ~ .checkmark {
      transform: scale(0.9);
    }

    input:checked ~ .checkmark {
      background: #af938d;
    }
  }
}
</style>
